import {
  IBreadcrumbStyleProps,
  IBreadcrumbStyles
} from '@fluentui/react/lib/Breadcrumb';
import { FontWeights, ITheme } from '@fluentui/react/lib/Styling';
import { FontSizes } from '../teams-type';

export function getBreadcrumbStyles(themeName: string, _theme: ITheme) {
  return (props: IBreadcrumbStyleProps): Partial<IBreadcrumbStyles> => {
    const { theme } = props;
    const { palette } = theme;

    const stateSelectors = {
      ':hover': {
        color: palette.themePrimary,
        textDecoration: 'none',
        backgroundColor: 'none'
      },
      ':active': {
        color: palette.themePrimary,
        backgroundColor: 'none',
        textDecoration: 'none'
      },
      '&:active:hover': {
        color: palette.themePrimary,
        backgroundColor: 'none',
        textDecoration: 'none'
      }
    };
    const styles = {
      root: {
        marginTop: 8,
        marginBottom: 0,
        paddingLeft: '24px',
        paddingRight: '24px',
        fontSize: FontSizes.size14,
        lineHeight: FontSizes.size20,
        selectors: {
          '.ms-Breadcrumb-listItem:last-child .ms-Breadcrumb-itemLink': {
            fontWeight: FontWeights.bold,
            color: palette.black
          },
          '.ms-Breadcrumb-listItem:last-child .ms-Breadcrumb-item': {
            fontWeight: FontWeights.bold
          }
        }
      },
      item: {
        color: palette.neutralDark,
        fontSize: FontSizes.size14,
        lineHeight: '40px',
        height: '40px',
        selectors: {
          ':last-child': {
            color: palette.neutralDark
          }
        }
      },
      itemLink: {
        fontSize: FontSizes.size14,
        lineHeight: '40px',
        outline: 'none',
        fontWeight: FontWeights.regular,
        color: palette.neutralDark,
        height: '40px',
        selectors: {
          '.ms-Fabric--isFocusVisible &:focus': {
            // Necessary due to changes of Link component not using getFocusStyle.
            outline: 'none'
          },
          ...stateSelectors
        }
      },
      chevron: {
        color: palette.neutralDark,
        fontSize: FontSizes.size12
      },
      overflowButton: {
        color: palette.neutralDark,
        selectors: {
          ...stateSelectors
        }
      }
    };

    // Contrast theme overrides
    if (themeName === 'contrast') {
      stateSelectors['&:active:hover'].color = palette.themeDark;
      stateSelectors[':hover'].color = palette.themeDark;
      stateSelectors[':active'].color = palette.themeDark;
    }
    return styles;
  };
}
